import { createEnv } from "@pushup/shared";
import { z } from "zod";

const schema = z.object({
  VITE_API_BASE_URL: z.string().min(1).default("/api"),
});

export const env = createEnv(schema, import.meta.env);
